import styled, { css } from "styled-components";
import {
  BorderRadius,
  BorderWidth,
  BoxShadow,
  CloseButton,
  Color,
  Layer,
  MediumTextM,
  Space,
  ToastVariant,
} from "@enxcs/dap-ui-stratos";

export const ToastCloseButton = styled(CloseButton)`
  right: ${Space.V16};
  position: fixed;
  top: ${Space.V16};
`;

export const ToastText = styled(MediumTextM)`
  white-space: pre-line;
`;

export const ToastIcon = styled.div`
  flex-shrink: 0;
`;

export interface ToastRootProps {
  $variant: ToastVariant;
}

export const ToastRoot = styled.div<ToastRootProps>`
  align-items: center;
  background-color: ${Color.Neutral.V00};
  border-left: ${BorderWidth.V8} solid transparent;
  border-radius: ${BorderRadius.V8};
  box-sizing: border-box;
  box-shadow: ${BoxShadow.V20};
  display: flex;
  gap: ${Space.V16};
  left: 50%;
  max-height: 50vh;
  max-width: 95vw;
  min-height: 90px;
  overflow: hidden;
  padding: ${Space.V16} ${Space.V40} ${Space.V16} ${Space.V16};
  position: fixed;
  top: 80px;
  transform: translateX(-50%);
  width: 350px;
  z-index: ${Layer.V70};

  ${(props) =>
    props.$variant === ToastVariant.PROGRESS &&
    css`
      border-left-color: ${Color.Blue.V40};

      ${ToastIcon} {
        color: ${Color.Blue.V40};
      }
    `}

  ${(props) =>
    props.$variant === ToastVariant.ERROR &&
    css`
      border-left-color: ${Color.Red.V30};

      ${ToastIcon} {
        color: ${Color.Red.V30};
      }
    `}

  ${(props) =>
    props.$variant === ToastVariant.SUCCESS &&
    css`
      border-left-color: ${Color.SpringGreen.V40};

      ${ToastIcon} {
        color: ${Color.SpringGreen.V40};
      }
    `}
`;
